import React, { Component } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import PropTypes from "prop-types";
import Paper from "@material-ui/core/Paper";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import {
  getSorting,
  getNumberSorting,
  getBooleanSorting,
} from "../components/Utils";
import {
  DRAWER_WIDTH,
  ACCOUNTS_TOOLBAR_HEIGHT,
  ACCOUNTS_TOOLBAR_TOP,
  MAIN_CONTENT_TOP,
  ROWS_PER_PAGE_OPTIONS,
} from "../components/Constants";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import PopupMessage from "../components/PopupMessage";
import ConfirmDialog from "../components/ConfirmDialog";
import CustomTableHead from "../components/CustomTableHead";

import CreateAccountPage from "../containers/CreateAccountPage";
import DownloadSoftwarePage from "../containers/DownloadSoftwarePage";
import StopPaymentsPage from "../containers/StopPaymentsPage";
import BillingInfoPage from "../containers/BillingInfoPage";
import UploadItemsPage from "../containers/UploadItemsPage";
import ManageCCPage from "../containers/ManageCCPage";
import AchPolicyPage from "../containers/AchPolicyPage";
import DepositLocationPage from "../containers/DepositLocationPage";
import SandBarcodePage from "../containers/SandBarcodePage";
import SandParametersPage from "../containers/SandParametersPage";
import AccountItemsConfigPage from "../containers/AccountItemsConfigPage";
import CustomPaginatorActions from "../components/CustomPaginatorActions";
import { getErrorString } from "../display/ErrorStrings";

import DeselectIcon from "@material-ui/icons/BackspaceOutlined";
//import DeleteAccountIcon from '@material-ui/icons/DeleteOutlined';
import ItemsIcon from "@material-ui/icons/DnsOutlined";
import BillingIcon from "@material-ui/icons/ReceiptOutlined";
import StopIcon from "@material-ui/icons/BrandingWatermarkOutlined";
import UploadIcon from "@material-ui/icons/PresentToAllOutlined";
import ManageCCIcon from "@material-ui/icons/AllInboxOutlined";
import BarcodeIcon from "@material-ui/icons/PermDataSettingOutlined";
import SANDParametersIcon from "@material-ui/icons/CameraEnhanceOutlined";
import ACHPPParametersIcon from "@material-ui/icons/MarkunreadMailboxOutlined";
import DepositLocationsIcon from "@material-ui/icons/LocationOnOutlined";
import ViewAccountsIcon from "@material-ui/icons/DnsOutlined";
import AddAccountIcon from "@material-ui/icons/LibraryAddOutlined";
import DownloadSANDIcon from "@material-ui/icons/SystemUpdateOutlined";

import CircularProgress from "@material-ui/core/CircularProgress";

const columnData = [
  { id: "active", numeric: false, disablePadding: true, label: " Active" },
  { id: "transit", numeric: false, disablePadding: true, label: "Transit" },
  { id: "account", numeric: false, disablePadding: true, label: "Account" },
  { id: "notes", numeric: false, disablePadding: true, label: "Notes" },
  {
    id: "rangeStart",
    numeric: false,
    disablePadding: true,
    label: "Range Start",
  },
  { id: "rangeEnd", numeric: false, disablePadding: true, label: "Range End" },
];

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: "auto",
    overflowY: "auto",

    position: "fixed",
    top: `${MAIN_CONTENT_TOP}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
    bottom: "0px",
  },
  chkExcCell: {
    color: "red",
  },
  achExcCell: {
    backgroundColor: "MistyRose",
  },
  achChkExcCell: {
    color: "red",
    backgroundColor: "MistyRose",
  },
  toolbar: {
    height: `${ACCOUNTS_TOOLBAR_HEIGHT}px`,
    zIndex: 1,
    position: "fixed",
    top: `${ACCOUNTS_TOOLBAR_TOP}px`,
    left: `${DRAWER_WIDTH}px`,
    right: "0px",
  },
  spacer: {
    flex: "1 1 100%",
  },
  disabledButton: {
    backgroundColor: theme.palette.secondary.main,
    fontWeight: "bold",
  },
  progress: {
    margin: theme.spacing.unit,
  },
  tableRow: {
    "&:hover": {
      backgroundColor: "secondary",
      cursor: "pointer",
    },
  },
});

class AccountsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      numAccouts: 0,
      accountsPerm: {},
      accounts: [],
      selectedAccountKey: 0,
      selectedAccountObject: {},
      order: "asc",
      orderBy: "",
      page: 0,
      rowsPerPage: window.sco_small_items_per_page,
      viewAccounts: true,
      accountsAction: 0,
      accountAction: 0,
      deleteDialog: false,
      deleteInProgress: false,
      deleteErrorString: "",
      redrawButtons: false,
      searchAcctsInProgress: false,
    };
    this.handleSubpageCallback = this.handleSubpageCallback.bind(this);
    this.handleDeleteErrorClick = this.handleDeleteErrorClick.bind(this);
    this.handleDeleteAccount = this.handleDeleteAccount.bind(this);
  }

  componentDidUpdate() {
    if (this.state.redrawButtons) {
      this.setState({ redrawButtons: false });
    }
  }
  handleAccountActions(event, action) {
    this.setState({ viewAccounts: false });
    this.setState({ accountAction: action });
    this.setState({ redrawButtons: true });
  }

  handleAccountsActions(event, action) {
    this.setState({ viewAccounts: false });
    this.setState({ accountsAction: action });
  }

  handleSubpageCallback() {
    this.setState({ viewAccounts: true });
    this.setState({ accountsAction: 0 });
  }

  handleSelectAccount(event, itemKey) {
    let items = this.state.accounts;
    let index;
    for (index = 0; index < items.length; index++) {
      if (items[index].key === itemKey) {
        this.setState({ selectedAccountObject: items[index] });
        break;
      }
    }
    this.setState({ selectedAccountKey: itemKey });
  }

  handleUnselectAccount(event) {
    this.setState({ selectedAccountKey: 0 });
    this.setState({ viewAccounts: true });
    this.setState({ accountsAction: 0 });
    this.setState({ accountAction: 0 });
    if (this.state.selectedAccountObject.hasExceptions) {
      this.componentDidMount();
    }
  }

  handleDeleteAccount(event, action) {
    let { t } = this.props;
    // action = 1 - confirmed
    if (action === 1) {
      this.setState({ deleteDialog: false });
      this.setState({ deleteInProgress: true });
      fetch("on_delete_account", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          transit: this.state.selectedAccountObject.transit,
          account: this.state.selectedAccountObject.account,
          rangeStart: this.state.selectedAccountObject.rangeStart,
          rangeEnd: this.state.selectedAccountObject.rangeEnd,
          secureToken: this.props.secureToken,
        }),
      })
        .then(function (res) {
          if (!res.ok) {
            throw Error(res.status + " (" + res.statusText + ")");
          }
          return res;
        })
        .then((res) => res.text())
        .then((text) => {
          var reply = JSON.parse(text);
          if (!reply.authenticated) {
            this.props.history.push("/expired");
          } else if (reply.error) {
            this.setState({ deleteErrorString: t(reply.errorString) });
          } else {
            let items = this.state.accounts;
            let index;
            let itemKey = this.state.selectedAccountKey;
            for (index = 0; index < items.length; index++) {
              if (items[index].key === itemKey) {
                items.splice(index, 1);
                this.setState({ accounts: items });
                this.setState({ numAccouts: items.length });
                break;
              }
            }
            this.setState({ selectedAccountKey: 0 });
            this.setState({ viewAccounts: true });
            this.setState({ accountsAction: 0 });
            this.setState({ accountAction: 0 });

            if (this.state.order === "desc") {
              this.setState({ order: "asc" });
            } else {
              this.setState({ order: "desc" });
            }

            this.handleRequestSort(null, this.state.orderBy);
          }
        })
        .catch((error) => {
          this.setState({
            deleteErrorString:
              getErrorString(
                "general.server.status.error",
                "The server responded with a status of "
              ) + error.message,
          });
        });
      this.setState({ deleteInProgress: false });
    }
    // action = 2 - cancelled
    else if (action === 2) {
      this.setState({ deleteDialog: false });
    }
    // action = 3 - open dialog
    else if (action === 3) {
      this.setState({ deleteDialog: true });
    }
  }

  handleDeleteErrorClick(event) {
    this.setState({ deleteErrorString: "" });
  }

  handleRequestSort = (event, property) => {
    if (property.indexOf("nosort") !== -1) {
      return;
    }
    const orderBy = property;
    let order = "desc";

    if (this.state.orderBy === property) {
      if (this.state.order === "desc") {
        order = "asc";
      }
    } else {
      order = this.state.order;
    }

    this.setState({ order, orderBy });
    let data = this.state.accounts;
    if (orderBy === "notes") {
      data.sort(getSorting(order, orderBy));
    } else if (orderBy === "active") {
      data.sort(getBooleanSorting(order, orderBy));
    } else {
      data.sort(getNumberSorting(order, orderBy));
    }
    this.setState({ accounts: data });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
    window.sco_small_items_per_page = event.target.value;
  };

  componentDidMount() {
    this.setState({ searchAcctsInProgress: true });
    fetch("on_accounts", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        r: new Date().getTime(),
        secureToken: this.props.secureToken,
      }),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (reply.authenticated === false) {
          this.props.history.push("/expired");
        } else {
          if (reply.error) this.setState({ errorString: reply.errorString });
          this.setState({ numAccounts: reply.numAccounts });
          this.setState({ accounts: reply.accounts });
          this.setState({ accountsPerm: reply.accountsPerm });
          this.setState({ searchAcctsInProgress: false });
        }
      })
      .catch((error) => {
        this.setState({ searchAcctsInProgress: false });
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
      });
  }

  isSelected = (id) => this.state.selectedAccountKey === id;

  render() {
    const { classes } = this.props;
    const { order, orderBy, rowsPerPage, page } = this.state;
    let { t } = this.props;
    let data = this.state.accounts;
    return (
      <div>
        {this.state.errorString.length > 0 && (
          <div className={classes.toolbar}>
            <h3 style={{ color: "red" }}>{this.state.errorString} </h3>
          </div>
        )}
        {this.state.numAccounts === 0 &&
          this.state.errorString.length === 0 &&
          !this.state.searchAcctsInProgress && (
            <div className={classes.toolbar}>
              <h3>{t("accountListEmpty.label")}</h3>
            </div>
          )}
        {this.state.selectedAccountKey > 0 && (
          <Paper className={classes.toolbar}>
            <Typography variant="body1" color="primary">
              &nbsp;&nbsp; {t("selectedTransit.label")}&nbsp;
              <span>
                <strong>{this.state.selectedAccountObject.transit}</strong>
              </span>
              &nbsp;&nbsp;{t("account.label")}&nbsp;
              <span>
                <strong>{this.state.selectedAccountObject.account}</strong>
              </span>
              &nbsp;&nbsp;{t("range.label")}&nbsp;
              <span>
                <strong>
                  {this.state.selectedAccountObject.rangeStart} -{" "}
                  {this.state.selectedAccountObject.rangeEnd}
                </strong>
              </span>
              &nbsp;&nbsp;
              <Button
                color="primary"
                onClick={(event) => this.handleUnselectAccount(event)}
              >
                <DeselectIcon />
                &nbsp;{t("deselect.button")}
              </Button>
              {/*this.state.selectedAccountObject.hasDeletePerm &&
								<Button color="primary" style={{ position: 'absolute', right: 10 }} onClick={event => this.handleDeleteAccount(event, 3)} disabled={this.state.deleteInProgress}><DeleteAccountIcon />&nbsp;{t('delete.button')}</Button>
							*/}
              <Divider />
            </Typography>
            {this.state.selectedAccountObject.active &&
              !this.state.redrawButtons && (
                <div>
                  <Tooltip title={t("searchAcctItem.tip")}>
                    <Button
                      variant="outlined"
                      color="primary"
                      classes={{
                        root: classes.button,
                        disabled: classes.disabledButton,
                      }}
                      onClick={(event) => this.handleAccountActions(event, 1)}
                      disabled={this.state.accountAction === 1}
                    >
                      <ItemsIcon />
                      &nbsp;{t("accountItems.button")}
                    </Button>
                  </Tooltip>

                  {this.state.accountsPerm.billingInfo && (
                    <Tooltip title={t("viewBillingInfo.tip")}>
                      <Button
                        variant="outlined"
                        color="primary"
                        classes={{
                          root: classes.button,
                          disabled: classes.disabledButton,
                        }}
                        onClick={(event) => this.handleAccountActions(event, 2)}
                        disabled={this.state.accountAction === 2}
                      >
                        <BillingIcon />
                        &nbsp;{t("billingInfo.button")}
                      </Button>
                    </Tooltip>
                  )}
                  {this.state.accountsPerm.readStopPayment &&
                    !this.props.uiExclusionsList.includes("STOP") && (
                      <Tooltip title={t("manageStop.tip")}>
                        <Button
                          variant="outlined"
                          color="primary"
                          classes={{
                            root: classes.button,
                            disabled: classes.disabledButton,
                          }}
                          onClick={(event) =>
                            this.handleAccountActions(event, 3)
                          }
                          disabled={this.state.accountAction === 3}
                        >
                          <StopIcon />
                          &nbsp;{t("stopPayments.button")}
                        </Button>
                      </Tooltip>
                    )}

                  {(this.state.selectedAccountObject.uploadItems ||
                    this.state.selectedAccountObject.issuedFiles) && (
                    <Tooltip title={t("manageIssue.tip")}>
                      <Button
                        variant="outlined"
                        classes={{
                          root: classes.button,
                          disabled: classes.disabledButton,
                        }}
                        color="primary"
                        onClick={(event) => this.handleAccountActions(event, 4)}
                        disabled={this.state.accountAction === 4}
                      >
                        <UploadIcon />
                        &nbsp;{t("issueItems.button")}
                      </Button>
                    </Tooltip>
                  )}

                  {(this.state.selectedAccountObject.cashierChecksPrint ||
                    this.state.selectedAccountObject.cashierChecksRequest ||
                    this.state.selectedAccountObject.cashierChecksReport ||
                    this.state.selectedAccountObject.cashierChecksApprove) && (
                    <Tooltip title={t("ccReport.tip")}>
                      <Button
                        variant="outlined"
                        classes={{
                          root: classes.button,
                          disabled: classes.disabledButton,
                        }}
                        color="primary"
                        onClick={(event) => this.handleAccountActions(event, 5)}
                        disabled={this.state.accountAction === 5}
                      >
                        <ManageCCIcon />
                        &nbsp;{t("ccManage.button")}
                      </Button>
                    </Tooltip>
                  )}

                  {this.state.selectedAccountObject
                    .configurePrintingSandBarcode &&
                    !this.props.uiExclusionsList.includes("SAND") && (
                      <Tooltip title={t("configSandBarcode.tip")}>
                        <Button
                          variant="outlined"
                          classes={{
                            root: classes.button,
                            disabled: classes.disabledButton,
                          }}
                          color="primary"
                          onClick={(event) =>
                            this.handleAccountActions(event, 6)
                          }
                          disabled={this.state.accountAction === 6}
                        >
                          <BarcodeIcon />
                          &nbsp;{t("barcode.button")}
                        </Button>
                      </Tooltip>
                    )}
                  {this.state.selectedAccountObject.configureSandParameters &&
                    !this.props.uiExclusionsList.includes("SAND") && (
                      <Tooltip title={t("configSandPara.tip")}>
                        <Button
                          variant="outlined"
                          classes={{
                            root: classes.button,
                            disabled: classes.disabledButton,
                          }}
                          color="primary"
                          onClick={(event) =>
                            this.handleAccountActions(event, 7)
                          }
                          disabled={this.state.accountAction === 7}
                        >
                          <SANDParametersIcon />
                          &nbsp;{t("sandParas.button")}
                        </Button>
                      </Tooltip>
                    )}
                  {this.state.selectedAccountObject.achPositivePayParams && (
                    <Tooltip title={t("configAch.tip")}>
                      <Button
                        variant="outlined"
                        classes={{
                          root: classes.button,
                          disabled: classes.disabledButton,
                        }}
                        color="primary"
                        onClick={(event) => this.handleAccountActions(event, 8)}
                        disabled={this.state.accountAction === 8}
                      >
                        <ACHPPParametersIcon />
                        &nbsp;{t("achPara.button")}
                      </Button>
                    </Tooltip>
                  )}
                  {this.state.selectedAccountObject
                    .configureDepositLocations && (
                    <Tooltip title={t("configLocation.tip")}>
                      <Button
                        variant="outlined"
                        classes={{
                          root: classes.button,
                          disabled: classes.disabledButton,
                        }}
                        color="primary"
                        onClick={(event) => this.handleAccountActions(event, 9)}
                        disabled={this.state.accountAction === 9}
                      >
                        <DepositLocationsIcon />
                        &nbsp;{t("depositLocations.button")}
                      </Button>
                    </Tooltip>
                  )}
                </div>
              )}
            {!this.state.selectedAccountObject.active && (
              <p style={{ color: "primary" }}>
                {" "}
                &nbsp;&nbsp; {t("inactiveAcct.label")}{" "}
              </p>
            )}
          </Paper>
        )}

        {this.state.deleteErrorString.length > 0 && (
          <PopupMessage
            title="ERROR"
            text={this.state.deleteErrorString}
            error={true}
            onClosePopup={this.handleDeleteErrorClick}
          />
        )}

        {this.state.deleteDialog && (
          <ConfirmDialog
            title={t("confirmDelete.label")}
            text={t("deleteRange.label")}
            onCloseConfirm={this.handleDeleteAccount}
          />
        )}
        {this.state.numAccounts > 0 &&
          this.state.errorString.length === 0 &&
          (this.state.viewAccounts || this.state.accountsAction > 0) &&
          this.state.selectedAccountKey === 0 && (
            <Paper className={classes.toolbar}>
              <Toolbar>
                <Typography variant="h6" color="primary">
                  {t("accounts.label")}&nbsp;&nbsp;
                </Typography>
                {!this.props.uiExclusionsList.includes("ACCOUNTS") && (
                  <Button
                    variant="outlined"
                    color="primary"
                    classes={{
                      root: classes.button,
                      disabled: classes.disabledButton,
                    }}
                    onClick={(event) => this.handleSubpageCallback(event)}
                    disabled={this.state.accountsAction === 0}
                  >
                    <ViewAccountsIcon />
                    &nbsp;{t("viewAccounts.button")}
                  </Button>
                )}
                {this.state.accountsPerm.addAccount && (
                  <Button
                    variant="outlined"
                    color="primary"
                    classes={{
                      root: classes.button,
                      disabled: classes.disabledButton,
                    }}
                    onClick={(event) => this.handleAccountsActions(event, 1)}
                    disabled={this.state.accountsAction === 1}
                  >
                    <AddAccountIcon />
                    &nbsp;{t("addAccount.button")}
                  </Button>
                )}
                {this.state.accountsPerm.sand &&
                  !this.props.uiExclusionsList.includes("SAND") && (
                    <Button
                      variant="outlined"
                      color="primary"
                      classes={{
                        root: classes.button,
                        disabled: classes.disabledButton,
                      }}
                      onClick={(event) => this.handleAccountsActions(event, 2)}
                      disabled={this.state.accountsAction === 2}
                    >
                      <DownloadSANDIcon />
                      &nbsp;{t("downloadSand.button")}
                    </Button>
                  )}
              </Toolbar>
            </Paper>
          )}

        {this.state.accountsAction === 1 &&
          !this.props.uiExclusionsList.includes("ACCOUNTS") && (
            <div>
              <CreateAccountPage
                history={this.props.history}
                uiExclusionsList={this.props.uiExclusionsList}
                viewOnly={this.props.viewOnly}
                secureToken={this.props.secureToken}
                onResult={this.handleSubpageCallback}
              />
            </div>
          )}
        {this.state.accountsAction === 2 &&
          !this.props.uiExclusionsList.includes("SAND") && (
            <div>
              <DownloadSoftwarePage
                history={this.props.history}
                uiExclusionsList={this.props.uiExclusionsList}
                viewOnly={this.props.viewOnly}
                secureToken={this.props.secureToken}
                onResult={this.handleSubpageCallback}
              />
            </div>
          )}

        {this.state.accountAction === 9 && (
          <div>
            <DepositLocationPage
              history={this.props.history}
              uiExclusionsList={this.props.uiExclusionsList}
              viewOnly={this.props.viewOnly}
              secureToken={this.props.secureToken}
              accountObject={this.state.selectedAccountObject}
              accountsPerm={this.state.accountsPerm}
            />
          </div>
        )}

        {this.state.accountAction === 8 && (
          <div>
            <AchPolicyPage
              history={this.props.history}
              uiExclusionsList={this.props.uiExclusionsList}
              viewOnly={this.props.viewOnly}
              secureToken={this.props.secureToken}
              accountObject={this.state.selectedAccountObject}
              accountsPerm={this.state.accountsPerm}
            />
          </div>
        )}

        {this.state.accountAction === 7 && (
          <div>
            <SandParametersPage
              history={this.props.history}
              uiExclusionsList={this.props.uiExclusionsList}
              viewOnly={this.props.viewOnly}
              secureToken={this.props.secureToken}
              accountObject={this.state.selectedAccountObject}
              accountsPerm={this.state.accountsPerm}
            />
          </div>
        )}

        {this.state.accountAction === 6 && (
          <div>
            <SandBarcodePage
              history={this.props.history}
              uiExclusionsList={this.props.uiExclusionsList}
              viewOnly={this.props.viewOnly}
              secureToken={this.props.secureToken}
              accountObject={this.state.selectedAccountObject}
              accountsPerm={this.state.accountsPerm}
            />
          </div>
        )}

        {this.state.accountAction === 5 && (
          <div>
            <ManageCCPage
              history={this.props.history}
              uiExclusionsList={this.props.uiExclusionsList}
              viewOnly={this.props.viewOnly}
              secureToken={this.props.secureToken}
              accountObject={this.state.selectedAccountObject}
              accountsPerm={this.state.accountsPerm}
            />
          </div>
        )}

        {this.state.accountAction === 4 && (
          <div>
            <UploadItemsPage
              history={this.props.history}
              uiExclusionsList={this.props.uiExclusionsList}
              viewOnly={this.props.viewOnly}
              secureToken={this.props.secureToken}
              accountObject={this.state.selectedAccountObject}
              accountsPerm={this.state.accountsPerm}
            />
          </div>
        )}

        {this.state.accountAction === 3 && (
          <div>
            <StopPaymentsPage
              history={this.props.history}
              uiExclusionsList={this.props.uiExclusionsList}
              viewOnly={this.props.viewOnly}
              secureToken={this.props.secureToken}
              accountObject={this.state.selectedAccountObject}
              accountsPerm={this.state.accountsPerm}
            />
          </div>
        )}
        {this.state.accountAction === 2 && (
          <div>
            <BillingInfoPage
              history={this.props.history}
              uiExclusionsList={this.props.uiExclusionsList}
              viewOnly={this.props.viewOnly}
              secureToken={this.props.secureToken}
              accountObject={this.state.selectedAccountObject}
              accountsPerm={this.state.accountsPerm}
            />
          </div>
        )}
        {this.state.accountAction === 1 &&
          !this.props.uiExclusionsList.includes("ACCOUNTS") && (
            <div>
              <AccountItemsConfigPage
                history={this.props.history}
                uiExclusionsList={this.props.uiExclusionsList}
                viewOnly={this.props.viewOnly}
                secureToken={this.props.secureToken}
                accountObject={this.state.selectedAccountObject}
                accountsPerm={this.state.accountsPerm}
              />
            </div>
          )}
        {this.state.numAccounts === 0 &&
          this.state.errorString.length === 0 &&
          this.state.searchAcctsInProgress && (
            <div className={classes.tableWrapper}>
              <br></br>
              <CircularProgress className={classes.progress} />
            </div>
          )}

        {this.state.numAccounts > 0 &&
          this.state.errorString.length === 0 &&
          this.state.viewAccounts &&
          !this.props.uiExclusionsList.includes("ACCOUNTS") && (
            <div className={classes.tableWrapper}>
              <TablePagination
                component="div"
                count={data.length}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
                page={page}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                ActionsComponent={CustomPaginatorActions}
              />

              <Paper>
                <Table
                  className={classes.table}
                  aria-labelledby="tableTitle"
                  stickyHeader
                >
                  <CustomTableHead
                    order={order}
                    orderBy={orderBy}
                    columnData={columnData}
                    onRequestSort={this.handleRequestSort}
                  />
                  <TableBody>
                    {data
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((n) => {
                        const isSelected = this.isSelected(n.key);
                        let titleStr = "";
                        if (!n.hasExceptions && !n.hasACHExceptions) {
                          titleStr = t("selectAcct.label");
                        }
                        if (n.hasExceptions && !n.hasACHExceptions) {
                          titleStr = t("selectAcctChkExc.label");
                        }
                        if (!n.hasExceptions && n.hasACHExceptions) {
                          titleStr = t("selectAcctAchExc.label");
                        }
                        if (n.hasExceptions && n.hasACHExceptions) {
                          titleStr = t("selectAcctChkAchExc.label");
                        }
                        return (
                          <TableRow
                            hover
                            className={classes.tableRow}
                            onClick={(event) =>
                              this.handleSelectAccount(event, n.key)
                            }
                            key={n.key}
                            selected={isSelected}
                            title={titleStr}
                          >
                            {n.hasExceptions && !n.hasACHExceptions && (
                              <TableCell className={classes.chkExcCell}>
                                {n.active ? t("yes.label") : t("no.label")}
                              </TableCell>
                            )}
                            {!n.hasExceptions && n.hasACHExceptions && (
                              <TableCell className={classes.achExcCell}>
                                {n.active ? t("yes.label") : t("no.label")}
                              </TableCell>
                            )}
                            {n.hasExceptions && n.hasACHExceptions && (
                              <TableCell className={classes.achChkExcCell}>
                                {n.active ? t("yes.label") : t("no.label")}
                              </TableCell>
                            )}
                            {!n.hasExceptions && !n.hasACHExceptions && (
                              <TableCell>
                                {n.active ? t("yes.label") : t("no.label")}
                              </TableCell>
                            )}
                            {n.hasExceptions && !n.hasACHExceptions && (
                              <TableCell className={classes.chkExcCell}>
                                {n.transit}
                              </TableCell>
                            )}
                            {!n.hasExceptions && n.hasACHExceptions && (
                              <TableCell className={classes.achExcCell}>
                                {n.transit}
                              </TableCell>
                            )}
                            {n.hasExceptions && n.hasACHExceptions && (
                              <TableCell className={classes.achChkExcCell}>
                                {n.transit}
                              </TableCell>
                            )}
                            {!n.hasExceptions && !n.hasACHExceptions && (
                              <TableCell>{n.transit}</TableCell>
                            )}
                            {n.hasExceptions && !n.hasACHExceptions && (
                              <TableCell className={classes.chkExcCell}>
                                {n.account}
                              </TableCell>
                            )}
                            {!n.hasExceptions && n.hasACHExceptions && (
                              <TableCell className={classes.achExcCell}>
                                {n.account}
                              </TableCell>
                            )}
                            {n.hasExceptions && n.hasACHExceptions && (
                              <TableCell className={classes.achChkExcCell}>
                                {n.account}
                              </TableCell>
                            )}
                            {!n.hasExceptions && !n.hasACHExceptions && (
                              <TableCell>{n.account}</TableCell>
                            )}
                            {n.hasExceptions && !n.hasACHExceptions && (
                              <TableCell className={classes.chkExcCell}>
                                {n.notes}
                              </TableCell>
                            )}
                            {!n.hasExceptions && n.hasACHExceptions && (
                              <TableCell className={classes.achExcCell}>
                                {n.notes}
                              </TableCell>
                            )}
                            {n.hasExceptions && n.hasACHExceptions && (
                              <TableCell className={classes.achChkExcCell}>
                                {n.notes}
                              </TableCell>
                            )}
                            {!n.hasExceptions && !n.hasACHExceptions && (
                              <TableCell>{n.notes}</TableCell>
                            )}
                            {n.hasExceptions && !n.hasACHExceptions && (
                              <TableCell className={classes.chkExcCell}>
                                {n.rangeStart}
                              </TableCell>
                            )}
                            {!n.hasExceptions && n.hasACHExceptions && (
                              <TableCell className={classes.achExcCell}>
                                {n.rangeStart}
                              </TableCell>
                            )}
                            {n.hasExceptions && n.hasACHExceptions && (
                              <TableCell className={classes.achChkExcCell}>
                                {n.rangeStart}
                              </TableCell>
                            )}
                            {!n.hasExceptions && !n.hasACHExceptions && (
                              <TableCell>{n.rangeStart}</TableCell>
                            )}
                            {n.hasExceptions && !n.hasACHExceptions && (
                              <TableCell className={classes.chkExcCell}>
                                {n.rangeEnd}
                              </TableCell>
                            )}
                            {!n.hasExceptions && n.hasACHExceptions && (
                              <TableCell className={classes.achExcCell}>
                                {n.rangeEnd}
                              </TableCell>
                            )}
                            {n.hasExceptions && n.hasACHExceptions && (
                              <TableCell className={classes.achChkExcCell}>
                                {n.rangeEnd}
                              </TableCell>
                            )}
                            {!n.hasExceptions && !n.hasACHExceptions && (
                              <TableCell>{n.rangeEnd}</TableCell>
                            )}
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </Paper>
            </div>
          )}
      </div>
    );
  }
}

AccountsPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(AccountsPage));
